/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';

import {Button} from 'shells/button';
import {StatusBadge, type Level} from 'shells/status-badge';

import './tertiary-action.module.css';

export type TertiaryActionPropsButton = {
    type: 'icon-button',
    icon: React.ComponentType<*>,
    onClick: (e: SyntheticEvent<*>) => void,
    color?: string,
    tootlipText?: string,
    getRef?: (?HTMLElement) => void,
    anchorElementId?: string,
};

type TertiaryActionPropsLink = {|
    type: 'text-button',
    text: string,
    onClick?: (PointerEvent) => void,
|};

type TertiaryActionPropsBadge = {
    type: 'badge',
    level: Level,
    text: string,
    detail?: string,
    icon?: React.Node,
};

export type TertiaryActionProps =
    | TertiaryActionPropsButton
    | TertiaryActionPropsLink
    | TertiaryActionPropsBadge;

export function TertiaryAction(props: TertiaryActionProps) {
    if (props.type === 'text-button') {
        return (
            <Button
                variant='text-primary'
                preventUnderline={true}
                onClick={props.onClick}
                noPadding={true}
                size='small'
            >
                {props.text}
            </Button>
        );
    }

    if (props.type === 'icon-button') {
        const Icon = props.icon;

        return (
            <button
                type='button'
                onClick={(e) => {
                    e.stopPropagation();

                    if (props.tootlipText) {
                        ReactTooltip.hide();
                    }

                    props.onClick(e);
                }}
                data-tip={props.tootlipText}
                ref={props.getRef}
                styleName='tertiary-action-button'
                id={props.anchorElementId}
            >
                <Icon size={16} color={props.color} fill={props.color} />
            </button>
        );
    }

    if (props.type === 'badge') {
        return (
            <StatusBadge
                size='small'
                customIcon={props.icon}
                level={props.level}
                text={props.text}
                detail={props.detail}
            />
        );
    }

    return null;
}
